<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.relatedPartyInfo">
      <div class="pa-3 content-wrapper">
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="formModel.applicantCasePartyId"
          :label="local.caseRelatedRequest.relatedPartyInfo"
          :items="prosecutorsCaseParties"
          item-value="casePartyId"
          item-text="name"
          validates="required"
          :disabled="casePartiesSelectboxDisabled"
        ></naj-input>
        <h6 class="request-applicant-type-message">
          {{ local.caseRelatedRequest.travelPreventionRequest.requestApplicantTypeMessage }}
        </h6>
      </div>
    </naj-box>

    <naj-box :title="local.caseRelatedRequest.travelPreventionRequest.title">
      <v-row>
        <v-col cols="6">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.defendantSocialId"
            :label="local.caseRelatedRequest.travelPreventionRequest.defendantName"
            :items="defendants"
            item-value="identityNumber"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
            @change="isDefendantSocialIdChanged"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, casePartyRoleEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'TravelPreventionRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      caseParties: [],
      defendants: [],
      selectedParties: [],
      selectedDefendant: {},
      isLoggedInUserExistsAsCaseParty: false,
      userCasePartyRoleInCase: {},
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    prosecutorsCaseParties() {
      return (this.caseParties || []).filter(cp => cp.casePartyRole == casePartyRoleEnum.prosecutor);
    },
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    casePartiesSelectboxDisabled() {
      return this.isViewMode || (this.formModel.applicantCasePartyId && this.isLoggedInUserExistsAsCaseParty);
    },
  },
  watch: {},
  mounted() {
    if (this.formModel) {
      this.readCurrentUserInfo();
    }
    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };
    Promise.all([
      this.getCaseRequestApplicants(params),
      this.getUserCasePartyRoleInCase(params),
    ])
      .then((res) => {
        this.caseParties = !this.isViewMode ? res[0].data.requestApplicants : [...res[0].data.prosecutors, ...res[0].data.defendants];
        this.defendants = res[0].data.defendants;
        this.userCasePartyRoleInCase = res[1].data;
        this.setRelatedPartyAsRequestApplicant();
      })
      .finally(() => (this.loading = false));
  },
  created() {
  },
  methods: {
    ...mapActions([
      'getCaseRequestApplicants',
      'getUserCasePartyRoleInCase',
    ]),
    isDefendantSocialIdChanged() {
      this.selectedDefendant = this.defendants.find(cp => cp.identityNumber == this.formModel.defendantSocialId);

      this.selectedParties = [{
        id: this.selectedDefendant.casePartyId,
        name: this.selectedDefendant.name,
        socialID: this.selectedDefendant.socialId,
        identityType: this.selectedDefendant.socialIdTypeName,
        lUTIdentityTypeID: this.selectedDefendant.socialIDType,
        nationalityID: this.selectedDefendant.nationalityID,
        nationality: this.selectedDefendant.nationality,
      }];
      this.$set(this.formModel, 'selectedParties', this.selectedParties);
    },
    setRelatedPartyAsRequestApplicant() {
      const selectedParty = this.prosecutorsCaseParties.find(cp => cp.partyId == this.userCasePartyRoleInCase.partyId);
      if (selectedParty) {
        this.isLoggedInUserExistsAsCaseParty = true;
        this.$set(this.formModel, 'applicantCasePartyId', this.formModel.applicantCasePartyId || selectedParty.casePartyId);
      }
    },
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'nationality', this.userInfo.nationality);
        this.$set(this.formModel, 'nationalityID', this.userInfo.nationalityID);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'nationality', null);
        this.$set(this.formModel, 'nationalityID', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.request-applicant-type-message {
  color: #2d8cf0;
}
</style>